import axios from "axios";
import useGlobalStore from "../stores/globalStore";
import ReactGA from "react-ga4";

export default function useHandleNAOrder() {
  //Form state
  const {
    nameRef,
    addressRef,
    postnumberRef,
    cityRef,
    emailRef,
    phoneRef,
    iAcceptPrivacy,
    selectedNetwork,
    toggleIsSending,
  } = useGlobalStore((state) => state);

  //Email string
  let emailString = `
  <div style="color:#333333; font-family: 'Arial', sans-serif;">
    <h1 style='color: #004493; text-transform: capitalize;'><span style='text-transform: capitalize;'>${
      selectedNetwork.title
    }</span></h1>
     <div>
        <h2 style='color: #cb1216'>Detaljer</h2>
        <p style='margin: 0;'><strong>Namn:</strong> ${nameRef}</p>
        <p style='margin: 0;'><strong>Email:</strong> ${emailRef}</p>
        <p style='margin: 0;'><strong>Telefon:</strong> ${phoneRef}</p>
        <p style='margin: 0;'><strong>Adress:</strong> ${addressRef}</p>
        <p style='margin: 0;'><strong>Postnumber:</strong> ${postnumberRef}</p>
        <p style='margin: 0;'><strong>Ort:</strong> ${cityRef}</p>
        <p style='margin: 0;'>${
          iAcceptPrivacy ? "Har accepterat privacy checkbox" : "Har inte accepterat privacy checkbox"
        }</p>
     </div>
</div>
  `;

  const handelOrder = async (e) => {
    toggleIsSending();
    // Add 'async' keyword here
    try {
      //Send order to API
      const response = await axios({
        // Correct variable name 'respons' to 'response'
        method: "POST",
        url: `../../../wp-content/plugins/tel-privata-tjanster-plugin/API/phpmailer.php`,
        headers: { "content-type": "application/json" },
        data: {
          fullOrder: emailString,
          formName: selectedNetwork.title,
          email: emailRef,
        },
      });

      if (response.data !== "sending") {
        console.error("Error: ", response);
        // Use strict equality check
        throw new Error(response.data);
      }

      // Logging to db
      const loggerResponsSuccess = await axios({
        method: "POST",
        url: `../../../wp-content/plugins/tel-privata-tjanster-plugin/API/order-logger.php`,
        headers: { "content-type": "application/json" },
        data: {
          personNr: "0000000000-0000",
          msg: emailString,
          formName: selectedNetwork.title,
          email: emailRef,
          status: "Skickat",
        },
      });

      //GA4 tracking
      ReactGA.event({
        category: "sending order",
        action: `Sent order form ${selectedNetwork.title}`,
        label: `Order form ${selectedNetwork.title}`, // optional
        nonInteraction: false, // optional, true/false
        transport: "xhr", // optional, beacon/xhr/image
      });

      //Redirect
      window.location.href = "https://www.teleservice.net/tack-for-bestallning/"; 

      toggleIsSending();
    } catch (error) {
      console.error(error.message);
      // Logging to db
      const loggerResponsError = await axios({
        method: "POST",
        url: `../../../wp-content/plugins/tel-privata-tjanster-plugin/API/order-logger.php`,
        headers: { "content-type": "application/json" },
        data: {
          personNr: "0000000000-0000",
          errorMsg: error.message,
          msg: emailString,
          formName: selectedNetwork.title,
          email: emailRef,
          status: "Ej skickat",
        },
      });
      toggleIsSending();
    } 
  };

  return handelOrder;
}
